export default __webpack_public_path__ + "static/media/pantry1-afterA.6a846945.jpg";